import script from "./PartCollectionButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartCollectionButtons.vue?vue&type=script&setup=true&lang=ts"

import "./PartCollectionButtons.vue?vue&type=style&index=0&id=7dd6a446&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd6a446"]])

export default __exports__